// src/components/Ielts_test/welcome/CategorySection.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {HeadphoneIcon, ReadingIcon, WritingIcon, SpeakingIcon} from "../../../assets"; 

const categories = [
  {
    icon: HeadphoneIcon,
    title: 'Listening Test',
    desc: 'Uji kemampuan mendengar dengan audio real IELTS',
    btnText: 'Mulai Test',
    route: '/listening-test',
  },
  {
    icon: ReadingIcon,
    title: 'Reading Test',
    desc: 'Latih pemahaman bacaan akademik dan umum',
    btnText: 'Mulai Test',
    route: '/reading-test',
  },
  {
    icon: WritingIcon,
    title: 'Writing Test',
    desc: 'Uji kemampuan menulis esai dan laporan',
    btnText: 'Mulai Test',
    route: '/writing-test',
  },
  {
    icon: SpeakingIcon,
    title: 'Speaking Test',
    desc: 'Latih kemampuan berbicara dengan simulasi wawancara',
    btnText: 'Mulai Test',
    route: '/speaking-test',
  },
];

const CategorySection = () => {
  const navigate = useNavigate(); // Hook untuk navigasi

  const handleStartTest = (route) => {
    navigate(route); // Arahkan ke halaman yang sesuai
  };

  return (
    <section
      id="category-section"
      className="py-10 px-4 md:py-16 md:px-8"
      style={{ backgroundColor: '#E0E7FF' }}
    >
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-primary font-poppins mb-10">
          Pilih Kategori IELTS yang akan kamu coba kerjakan
        </h2>

        {/* Grid Responsif */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat, index) => (
            <div
              key={index}
              className="bg-gradient-to-r from-[#1e3e7e] to-[#a51c30] rounded-2xl shadow-lg p-4 md:p-6 flex flex-col items-center text-center transition hover:shadow-xl hover:-translate-y-1 cursor-pointer"
              onClick={() => handleStartTest(cat.route)} // Bisa klik seluruh card
            >
              {/* Icon */}
              <div className="w-12 h-12 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center p-2 md:p-3 mb-3 md:mb-4 shadow-md">
                <img
                  src={cat.icon}
                  alt={cat.title}
                  className="w-full h-full object-contain"
                />
              </div>

              {/* Judul */}
              <h3 className="text-sm md:text-lg font-semibold text-white font-poppins mb-1 md:mb-2 line-clamp-2">
                {cat.title}
              </h3>

              {/* Deskripsi */}
              <p className="text-xs md:text-sm text-white/90 font-roboto mb-3 md:mb-4 flex-1 line-clamp-3">
                {cat.desc}
              </p>

              {/* Tombol */}
              <button
                onClick={(e) => {
                  e.stopPropagation(); // Cegah double trigger
                  handleStartTest(cat.route);
                }}
                className="bg-accent text-primary font-poppins font-semibold px-3 py-1.5 md:px-5 md:py-2 rounded-full hover:bg-yellow-500 transition text-xs md:text-sm shadow-md w-full"
              >
                {cat.btnText}
              </button>

              {cat.title === 'Speaking Test' && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/speaking/history');
                  }}
                  className="mt-2.5 bg-transparent border-2 border-white text-white font-poppins font-semibold px-3 py-1.5 md:px-5 md:py-2 rounded-full hover:bg-white hover:text-[#1e3e7e] transition text-xs md:text-sm shadow-md w-full cursor-pointer"
                >
                  Lihat History
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;